import { JumpToModule } from './../../../widgets/jump-to/jump-to.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeepDiveNewRoutingModule } from './deep-dive-new-routing.module';
import { DeepDiveNewComponent } from './deep-dive-new.component';
import { DxChartModule, DxDropDownButtonModule, DxTextAreaModule, DxRangeSelectorModule, DxDataGridModule, DxButtonModule, DxPopupModule, DxSwitchModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { SharedModule } from 'src/app/pipes/shared-module';
import { TaskPopupModule } from '../../task/task-popup/task-popup.module';
import { TaskListPopupModule } from '../../task/task-list-popup/task-list-popup.module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { DeepdiveV1Component } from './deepdive-v1/deepdive-v1.component';
import { DeepdiveV2Component } from './deepdive-v2/deepdive-v2.component';
import { BookmarksControlsComponent } from 'src/app/widgets/bookmark-new/bookmarks-controls/bookmarks-controls.component';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { GlobalizeNumberPipe } from 'src/app/pipes/globalize/globalize-number.pipe';
import { NumberBoxComponent } from 'src/app/components/number-box/number-box/number-box.component';

@NgModule({
	declarations: [DeepDiveNewComponent, DeepdiveV1Component, DeepdiveV2Component],
	imports: [
		CommonModule,
		SharedModule,
		GlobalizeNumberPipe,

		NumberBoxComponent,
		TaskPopupModule,
		TaskListPopupModule,
		BookmarkModule,
		JumpToModule,
		BookmarksControlsComponent,
		BookmarkNewComponent,
		ContainerComponent,
		DxTableControllerDirective,

		DxChartModule,
		DxDropDownButtonModule,
		DxTextAreaModule,
		DxRangeSelectorModule,
		DxDataGridModule,
		DevEpressCommonModule,
		DxButtonModule,
		DxPopupModule,
		DxSwitchModule,

		DeepDiveNewRoutingModule,
	]
})
export class DeepDiveNewModule { }
